import { defineMessages } from 'react-intl'

const scope = 'app.containers.InfluencersTablePage'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Influencers',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Influencers: {displayed} of {total}',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
